import { connect } from 'react-redux';
import ZendeskComponent from '../../../components/tools/zendesk/ZendeskComponent';
import { setSelectedTool } from '../../../actions/tools/ToolActions';
import { setCurrentPage } from '../../../actions/tools/ZendeskActions';

function mapStateToProps(state) {
  return {
    zendesk: Object.assign({}, state.tools && state.tools.zendesk),
  };
}

const mapDispatchToProps = (dispatch) => ({
  showKnowledgeBasePage() {
    dispatch(setSelectedTool('ACTIONS'));
  },
  showAllZendeskArticlesPage() {
    dispatch(setCurrentPage('allArticles'));
    dispatch(setSelectedTool('ZENDESK'));
  },
});

const ZendeskContainer = connect(mapStateToProps, mapDispatchToProps)(ZendeskComponent);

export default ZendeskContainer;
